module.exports = __webpack_public_path__ + "img/icon_map_5_off_011.278c4207.png";